import * as tslib_1 from "tslib";
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AutosuggestService = /** @class */ (function () {
    function AutosuggestService(http) {
        this.http = http;
        this.results$ = new BehaviorSubject({ items: [], totalResultCount: 0, pageCount: 0, initialRequest: true, searchPageUrl: null });
        this.headers = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
    }
    AutosuggestService.prototype.getResults = function () {
        return this.results$;
    };
    AutosuggestService.prototype.getSuggestionsFor = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof query !== 'string' || query.length <= 2) {
                            return [2 /*return*/, this.clear()];
                        }
                        return [4 /*yield*/, this.http.post(config.searchApi + 'autocomplete', { query: query, page: 0 }, { headers: this.headers }).toPromise()
                                .catch(function (err) {
                                if (err.status === 404) {
                                    console.error("\n            Dear developer, please check or specify the property 'searchApi:\n            \"/your/search/api\"' in the project's app.config.ts\n          ");
                                }
                                return null;
                            })];
                    case 1:
                        results = _a.sent();
                        results ? this.results$.next(results) : this.clear();
                        return [2 /*return*/];
                }
            });
        });
    };
    AutosuggestService.prototype.clear = function () {
        this.results$.next({ items: [], totalResultCount: 0, pageCount: 0, initialRequest: true, searchPageUrl: null });
    };
    AutosuggestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AutosuggestService_Factory() { return new AutosuggestService(i0.ɵɵinject(i1.HttpClient)); }, token: AutosuggestService, providedIn: "root" });
    return AutosuggestService;
}());
export { AutosuggestService };
